import { animationTransition } from '@shared/utils/animationTransition';
import { Box, styled } from '@withjoy/joykit';

export const StyledExpandableChecklist = styled(Box)`
  display: grid;
  grid-template-rows: 0fr;
  overflow: hidden;
  opacity: 0;
  transition: ${animationTransition('grid-template-rows', 'opacity')};
  .expanded & {
    grid-template-rows: 1fr;
    opacity: 1;
  }
`;
